import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-background" }
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { class: "top" }
const _hoisted_4 = { class: "modal-buttons" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalWindow',
  emits: [
		'close'
	],
  setup(__props, { emit: __emit }) {


	const emit = __emit;

	function close() {
		emit('close');
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "modal-fade" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", null, [
              _renderSlot(_ctx.$slots, "header", {}, () => [
                _createTextVNode(" Error ")
              ])
            ]),
            _renderSlot(_ctx.$slots, "content", {}, () => [
              _createTextVNode(" Something went wrong ")
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "buttons", {}, () => [
              _createElementVNode("button", { onClick: close }, "Ok")
            ])
          ])
        ])
      ])
    ]),
    _: 3
  }))
}
}

})